// load IFrame Player API code
if(document.documentElement.clientWidth > 768) {
  var iFrameApiTag = document.createElement('script');
  iFrameApiTag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(iFrameApiTag, firstScriptTag);

  // creates <iframe> (and YouTube player) after the API code downloads
  var ytPlayer;
  function onYouTubeIframeAPIReady() {
    ytPlayer = new YT.Player('bourbonVideo', {
      height: '390',
      width: '640',
      videoId: '1LJmpK0Wzx4',
      playerVars: { rel: 0, controls: 1 },
      events: {
        'onStateChange': onPlayerStateChange
      }
    });
  }

  // The API calls this function when the player's state changes.
  var playerInterval;
  function onPlayerStateChange(event) {
    if(event.data == YT.PlayerState.PLAYING) {
      playerInterval = setInterval(function(){
        bourbonTimeline(ytPlayer.getCurrentTime());
      }, 250);
    }
    if(event.data == YT.PlayerState.PAUSED || event.data == YT.PlayerState.ENDED){
      clearInterval(playerInterval);
    }
  }

  var bourbonItems = CSSRulePlugin.getRule('.bourbon-products .bourbon-product-wrap a');
  function transitionBourbonItems(previous, current){
    if(previous !== ''){
      document.querySelector(previous).classList.remove('active');
    }
    if(current !== ''){
      document.querySelector(current).classList.add('active');
    }
  }

  function bourbonTimeline(time) {
    if (time > 66) {
      gsap.to(bourbonItems, { cssRule:{opacity: '1'} });
      transitionBourbonItems('#hpBourbonGlasses a', '');
    } else if (time > 61.5) {
      transitionBourbonItems('#hpBourbonPress a', '#hpBourbonGlasses a');
      gsap.to(bourbonItems, { cssRule:{opacity: '.2'} });
    } else if (time > 45) {
      gsap.to(bourbonItems, { cssRule:{opacity: '1'} });
    } else if (time > 39) {
      transitionBourbonItems('#hpBourbonMold a', '#hpBourbonPress a');
    } else if (time > 22) {
      transitionBourbonItems('#hpBourbonMixer a', '#hpBourbonMold a');
    } else if (time > 4) {
      transitionBourbonItems('', '#hpBourbonMixer a');
      gsap.to(bourbonItems, { cssRule:{opacity: '.1'} });
    }
  };
}